import { render, staticRenderFns } from "./Hours.vue?vue&type=template&id=f452b28c&scoped=true&"
import script from "./Hours.vue?vue&type=script&lang=js&"
export * from "./Hours.vue?vue&type=script&lang=js&"
import style0 from "./Hours.vue?vue&type=style&index=0&id=f452b28c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f452b28c",
  null
  
)

export default component.exports